module.exports = __webpack_public_path__ + "img/contest-detail.5874fb39.webp";